import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, LogOut } from "lucide-react";
import api, { errMsg } from "../../lib/api";
import { useApp } from "../../context/AppContext";
import SEO from "../../components/SEO";
import { TextF } from "./AFields";

export default function MyAccount() {
  const { user, setUser, logout } = useApp();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: user?.name || "", username: user?.username || "", email: user?.email || "", mobile: user?.mobile || "" });
  const [pw, setPw] = useState({ current_password: "", new_password: "" });
  const [busy, setBusy] = useState(false);

  const saveProfile = async () => {
    setBusy(true);
    try {
      const r = await api.put("/auth/profile", form);
      setUser(r.data);
      toast.success("Profile updated");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  const changePw = async () => {
    setBusy(true);
    try {
      await api.post("/auth/change-password", pw);
      setPw({ current_password: "", new_password: "" });
      toast.success("Password changed");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div data-testid="admin-account">
      <SEO title="My Account" />
      <h1 className="font-display text-2xl font-bold tracking-tight text-navy sm:text-3xl">My Account</h1>
      <p className="mt-1 text-sm text-slate-500">Signed in as <b>{user?.email}</b> ({user?.role}){user?.last_login ? ` · last login ${String(user.last_login).slice(0, 16).replace("T", " ")}` : ""}</p>

      <div className="mt-6 grid gap-6 lg:grid-cols-2">
        <div className="space-y-5 rounded-lg border border-gray-200 bg-white p-6 sm:p-8" data-testid="profile-form">
          <h2 className="text-sm font-bold uppercase tracking-wider text-slate-500">Profile</h2>
          <TextF label="Full Name" value={form.name} onChange={(v) => setForm({ ...form, name: v })} />
          <TextF label="Username" value={form.username} onChange={(v) => setForm({ ...form, username: v })} />
          <TextF label="Email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} />
          <TextF label="Mobile" value={form.mobile} onChange={(v) => setForm({ ...form, mobile: v })} />
          <button onClick={saveProfile} disabled={busy} className="btn-primary !rounded-md !px-6 !py-2.5 text-sm disabled:opacity-50" data-testid="profile-save">
            {busy && <Loader2 size={15} className="animate-spin" />} Save Profile
          </button>
        </div>

        <div className="space-y-5 rounded-lg border border-gray-200 bg-white p-6 sm:p-8" data-testid="account-password">
          <h2 className="text-sm font-bold uppercase tracking-wider text-slate-500">Change Password</h2>
          <TextF label="Current Password" type="password" value={pw.current_password} onChange={(v) => setPw({ ...pw, current_password: v })} />
          <TextF label="New Password (min 8 chars)" type="password" value={pw.new_password} onChange={(v) => setPw({ ...pw, new_password: v })} />
          <button onClick={changePw} disabled={busy} className="btn-dark !rounded-md !px-6 !py-2.5 text-sm disabled:opacity-50" data-testid="account-password-save">Change Password</button>
          <hr className="border-gray-100" />
          <button onClick={async () => { await logout(); navigate("/superadmin/login"); }} data-testid="account-logout"
            className="inline-flex items-center gap-2 rounded-md border border-red-200 px-5 py-2.5 text-sm font-bold text-red-500 transition-colors hover:bg-red-50">
            <LogOut size={15} /> Logout
          </button>
        </div>
      </div>
    </div>
  );
}
